import React from "react";

const FormContainer = ({
  title,
  subtitle,
  children,
  className = "",
  ...props
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-600 to-red-800 rounded-2xl shadow-lg mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Admin Portal</h1>
          <div className="w-16 h-1 bg-gradient-to-r from-red-600 to-red-800 mx-auto rounded-full"></div>
        </div>

        <div className="bg-white/80 backdrop-blur-sm border border-white/20 shadow-2xl rounded-3xl overflow-hidden">
          <div className="bg-gradient-to-r from-red-600 to-red-800 px-8 py-6">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-white mb-1">{title}</h2>
              {subtitle && (
                <p className="text-red-100 text-sm font-medium">{subtitle}</p>
              )}
            </div>
          </div>

          <div className="px-8 py-8">
            <div className={`text-left ${className}`} {...props}>
              {children}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center">
          <p className="text-xs text-gray-500 font-medium">
            Secure Admin Access • Protected by Advanced Authentication
          </p>
        </div>
      </div>
    </div>
  );
};

export default FormContainer;
